import { useEffect, useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import React from "react";

import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";
import { EditTicketCategoryDialog } from "./EditTicketCategoryDialog";
import { CreateTicketCategoryDialog } from "./CreateTicketCategoryDialog";
import { ICONS } from "../../utils/icons";

export const TicketCategories = ({
  event,
  setEvent,
  handleSnackbar,
  supabase,
  userData,
}) => {
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [ticketCategory, setTicketCategory] = useState();
  const [ticketCategories, setTicketCategories] = useState([]);

  const handleOpenCreatePopup = () => {
    setOpenCreateDialog(true);
  };

  const handleOpenEditPopup = (index) => {
    setTicketCategory(index);
    setOpenEditDialog(true);
  };

  useEffect(() => {
    setTicketCategories(
      event.ticket_categories?.map((item) => {
        return {
          ...item,
        };
      })
    );
  }, [event]);

  return (
    <div>
      {openEditDialog && (
        <EditTicketCategoryDialog
          openPopup={openEditDialog}
          setOpenPopup={setOpenEditDialog}
          category={ticketCategory}
          categories={event.ticket_categories}
          currency={event?.currency}
          handleSnackbar={handleSnackbar}
          event={event}
          setEvent={setEvent}
          supabase={supabase}
          userData={userData}
        />
      )}
      {openCreateDialog && (
        <CreateTicketCategoryDialog
          openPopup={openCreateDialog}
          setOpenPopup={setOpenCreateDialog}
          category={ticketCategory}
          categories={event.ticket_categories}
          currency={event?.currency}
          handleSnackbar={handleSnackbar}
          sup
          event={event}
          setEvent={setEvent}
          supabase={supabase}
          userData={userData}
        />
      )}
      <div style={{ height: "20px" }} />
      <div className="standard-container" style={{ marginBottom: "20px" }}>
        <h2>Manage available ticket categories</h2>
        <p id="subTitle" style={{ marginBottom: "20px" }}>
          Keep track of your ticket categories & their quotas.
        </p>
        <MainButton
          text={"Create new ticket category"}
          color={COLORS.black}
          hoverColor={COLORS.black}
          textColor={COLORS.white}
          borderColor={COLORS.black}
          shadowColor={COLORS.mainAccent}
          textHoverColor={COLORS.lightGrey}
          onClickAction={() => handleOpenCreatePopup()}
          width={"fit-content"}
        >
          {ICONS.plus20}
        </MainButton>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {ticketCategories?.length == 0 && <p>No ticket categories</p>}
        {ticketCategories?.map((category, index) => (
          <div
            key={index}
            className="small-container"
            style={{
              height: "90px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    fontFamily: "DrukWideCy",
                    fontSize: "18px",
                  }}
                >
                  {category?.name}
                </p>
                <div
                  className="container-row"
                  style={{ justifyContent: "space-between" }}
                >
                  <p id="subheader">
                    Price: {category?.price} {event?.currency}
                  </p>
                  <p id="subheader">
                    Supply: {category?.supply.total} | Sold:{" "}
                    {category?.supply.sold}
                  </p>
                </div>
              </div>
              {ICONS.ticketGrey20}
            </div>
            <div className="container-row" style={{ marginTop: "15px" }}>
              <MainButton
                text={"Edit"}
                color={"transparent"}
                hoverColor={"transparent"}
                textColor={COLORS.black}
                borderColor={COLORS.black}
                shadowColor={COLORS.mainAccent}
                textHoverColor={COLORS.grey}
                onClickAction={() => handleOpenEditPopup(index)}
                width={"fit-content"}
              >
                {<AiOutlineEdit size={20} />}
              </MainButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
